/*
 * Copyright © 2019 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */

import {IAugmentedJQuery, IDirective, IDirectiveFactory, IDirectiveLinkFn, IScope, ITimeoutService} from 'angular';
import {DVSchadenfaelleListController} from '../../component/dv-schadenfaelle-list/dv-schadenfaelle-list';
import FilterPersistenceService from '../../service/FilterPersistenceService';

/**
 * This directive allows a filter and sorting configuration to be saved after leaving the table.
 * The information will be stored in an angular-service, whi
 */
export default class DvSchadenfaelleListPersist implements IDirective {
    public static $inject: string[] = ['FilterPersistenceService', '$timeout'];

    public restrict = 'A';
    public require = ['^stTable', '^dvSchadenfaelleList'];
    public link: IDirectiveLinkFn;

    public constructor(
        private readonly filterPersistenceService: FilterPersistenceService,
        private readonly $timeout: ITimeoutService,
    ) {
        this.link = (scope: IScope, _element: IAugmentedJQuery, attrs, ctrlArray: any) => {
            const nameSpace: string = attrs.dvSchadenfaelleListPersist;
            const ctrl = this;

            const stTableCtrl = ctrlArray[0];
            const schadenfaelleListController: DVSchadenfaelleListController = ctrlArray[1];

            $timeout(function () {
                ctrl.restoreData(nameSpace, stTableCtrl, schadenfaelleListController);
            }, 0);
            $timeout(function () {
                ctrl.addWatcher(scope, stTableCtrl, nameSpace, schadenfaelleListController);
            }, 0);
        };

    }

    private addWatcher(scope: IScope, stTableCtrl: any, nameSpace: string, schadenfaelleListController: DVSchadenfaelleListController): void {
        scope.$watch(() => stTableCtrl.tableState(), (newValue, oldValue) => {
            if (newValue !== oldValue) {
                this.filterPersistenceService.persistFilter(nameSpace, newValue);
                schadenfaelleListController.showResetFilter =
                    newValue.search.predicateObject !== undefined ||
                    newValue.sort.predicate !== 'ereignisdatum' ||
                    newValue.sort.reverse;
            }
        }, true);

        scope.$watch(() => this.filterPersistenceService.restoreFilter(nameSpace), (newValue, oldValue) => {
            if (newValue !== oldValue) {
                if (newValue === undefined) {
                    this.restoreData(nameSpace, stTableCtrl, schadenfaelleListController);
                }
            }
        }, true);
    }

    private restoreData(
        nameSpace: string,
        stTableCtrl: any,
        schadenfaelleListController: DVSchadenfaelleListController,
    ): void {
        const savedState = this.filterPersistenceService.restoreFilter(nameSpace);
        if (!savedState) {
            const defaultSort: any = {
                sort: {
                    predicate: 'ereignisdatum',
                    reverse: false,
                },
            };
            const tableState = stTableCtrl.tableState();
            delete tableState.search.predicateObject;
            schadenfaelleListController.selectedFallNummer = '';
            schadenfaelleListController.selectedGesuchstellerName = '';
            schadenfaelleListController.selectedEreignis = '';
            schadenfaelleListController.selectedOrt = '';
            schadenfaelleListController.selectedGesuchsdatumVon = '';
            schadenfaelleListController.selectedGesuchsdatumBis = '';
            schadenfaelleListController.selectedStatus = '';
            schadenfaelleListController.selectedVerantworlticher = '';
            schadenfaelleListController.selectedKostenVon = undefined;
            schadenfaelleListController.selectedKostenBis = undefined;
            schadenfaelleListController.selectedKanton = undefined;
            schadenfaelleListController.selectedSprache = undefined;
            angular.extend(tableState, defaultSort);
            stTableCtrl.pipe();
            return;
        }
        angular.extend(stTableCtrl.tableState(), savedState);
        if (savedState.search && savedState.search.predicateObject) {
            schadenfaelleListController.selectedFallNummer
                = savedState.search.predicateObject.fallNummer;
            schadenfaelleListController.selectedGesuchstellerName
                = savedState.search.predicateObject.gesuchstellerName;
            schadenfaelleListController.selectedEreignis
                = savedState.search.predicateObject.ereignis;
            schadenfaelleListController.selectedOrt
                = savedState.search.predicateObject.ort;
            schadenfaelleListController.selectedGesuchsdatumVon
                = savedState.search.predicateObject.gesuchsdatumVon;
            schadenfaelleListController.selectedGesuchsdatumBis
                = savedState.search.predicateObject.gesuchsdatumBis;
            schadenfaelleListController.selectedStatus
                = savedState.search.predicateObject.status;
            schadenfaelleListController.selectedVerantworlticher
                = savedState.search.predicateObject.verantwortlicher;
            schadenfaelleListController.selectedKostenVon
                = savedState.search.predicateObject.selectedKostenVon;
            schadenfaelleListController.selectedKostenBis
                = savedState.search.predicateObject.selectedKostenBis;
            schadenfaelleListController.selectedKanton
                = savedState.search.predicateObject.selectedKanton;
            schadenfaelleListController.selectedSprache
                = savedState.search.predicateObject.selectedSprache;
        }

        schadenfaelleListController.showResetFilter =
            savedState.search.predicateObject !== undefined ||
            savedState.sort.predicate !== 'ereignisdatum' ||
            savedState.sort.reverse;
        stTableCtrl.pipe();
    }

    public static factory(): IDirectiveFactory {
        const directive = (
            filterPersistenceService: any,
            $timeout: any,
        ) => new DvSchadenfaelleListPersist(filterPersistenceService, $timeout);
        directive.$inject = ['FilterPersistenceService', '$timeout'];
        return directive;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/directive/dv-schadenfaelle-list-persist/dv-schadenfaelle-list-persist.ts